import moment from "moment";

export const isMemberActive = (member) =>
  member.status === "active" && moment(member.endOfSubscription).isAfter(moment(), "day");

export const sortMembersActiveFirst = (members) =>
  [...members].sort((a, b) => Number(isMemberActive(b)) - Number(isMemberActive(a)));
